export const GET_CURRENT_RECEIPT = 'GET_CURRENT_RECEIPT';
export const SET_CHOSEN_RECEIPT = 'SET_CHOSEN_RECEIPT';
export const GET_CLIENT_INFO = 'GET_CLIENT_INFO';
export const APPLY_BONUSES = 'APPLY_BONUSES';
export const SUBMIT_LOYALTY_ORDER = 'SUBMIT_LOYALTY_ORDER';

export const RESET_CLIENT_INFO = 'RESET_CLIENT_INFO';
export const RESET_CURRENT_RECEIPT = 'RESET_CURRENT_RECEIPT';
export const RESET_APPLY_BONUSES = 'RESET_APPLY_BONUSES';
export const RESET_SUBMIT_ORDER = 'RESET_SUBMIT_ORDER';

export const GENERATE_LOYALTY_REPORT = 'GENERATE_LOYALTY_REPORT';
